import ContactsToolbar from "../../components/ContactsToolbar";
import InvitationGrid from "../../components/InvitationGrid";
import InvitationCard from "../../components/InvitationCard";
import EmptyState from "../../components/EmptyState";
import useGroupInvitations from "../../hooks/useGroupInvitations";
import { MailPlus } from "lucide-react";

const GroupInvitationsTab = () => {
  const { items, loading, reload } = useGroupInvitations({ days: 30 });

  return (
    <div className="flex flex-col h-full">
      <ContactsToolbar
        title="Lời mời vào nhóm"
        subtitle={`${items.length} nhóm tham gia 30 ngày gần đây`}
        onReload={reload}
        loading={loading}
        showFilter={false}
      />
      <div className="flex-1 overflow-auto">
        {!loading && items.length === 0 ? (
          <EmptyState
            icon={MailPlus}
            title="Chưa có lời mời nào"
            description="Hiển thị các nhóm Zalo mà tài khoản mới tham gia trong 30 ngày gần đây."
          />
        ) : (
          <InvitationGrid>
            {items.map((g) => (
              <InvitationCard
                key={`${g.shopId}:${g.uid}`}
                avatar={g.avatar}
                title={g.name || "(Nhóm không tên)"}
                subtitle={
                  g.totalMember != null ? `${g.totalMember} thành viên` : null
                }
                createdAt={g.createdAt}
                status="accepted"
                shopName={g.shop?.name}
              />
            ))}
          </InvitationGrid>
        )}
      </div>
    </div>
  );
};

export default GroupInvitationsTab;
